import { useContext, ref, readonly, computed, reactive } from "@nuxtjs/composition-api";
import getSwatchDataGql from "./getSwatchData.gql";
const state = reactive({
  attributeGroups: null,
  deliveryTime: null,
  deliveryTimeSwatchData: null
});
function useWmAttributes() {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { app } = useContext();
  const loading = ref(false);
  const error = ref({
    attributeGroups: null,
    getSwatchData: null
  });
  const productAttributes = computed(() => {
    let attributes = {};
    if (!state.attributeGroups)
      return attributes;
    state.attributeGroups.forEach((group) => {
      var _a2;
      if ((_a2 = group.attributes) == null ? void 0 : _a2.length) {
        group.attributes.forEach((a) => {
          attributes[a.attribute_code] = a;
        });
      }
    });
    return attributes;
  });
  const customAttributeNames = ((_b = (_a = app.$wm) == null ? void 0 : _a.catalog) == null ? void 0 : _b.customAttributeNames) ? app.$wm.catalog.customAttributeNames : {};
  const specificationExcludeAtts = ((_d = (_c = app.$wm) == null ? void 0 : _c.catalog) == null ? void 0 : _d.specificationExcludeAtts) ? app.$wm.catalog.specificationExcludeAtts : [];
  const productIdentifierAtts = [...((_f = (_e = app.$wm) == null ? void 0 : _e.catalog) == null ? void 0 : _f.additionalProductIdentifiers) ? app.$wm.catalog.additionalProductIdentifiers : []];
  const stockConfig = (_h = (_g = app.$wm) == null ? void 0 : _g.catalog) == null ? void 0 : _h.stock;
  const productIdentifiers = computed(() => {
    return productIdentifierAtts.map((i) => {
      var _a2;
      if ((_a2 = productAttributes.value) == null ? void 0 : _a2[i]) {
        return {
          label: productAttributes.value[i].attribute_label || "",
          value: productAttributes.value[i].value || ""
        };
      }
      return null;
    }).filter((a) => !!a && a.value);
  });
  const loadAttributeGroups = async (sku) => {
    state.attributeGroups = null;
    if (!sku) {
      return state.attributeGroups;
    }
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.wmProductAttributeGroups(sku);
      state.attributeGroups = (data == null ? void 0 : data.wmProductAttributeGroups) || null;
      if (stockConfig.useCustomField && productAttributes.value[stockConfig.customField]) {
        if (!state.deliveryTimeSwatchData) {
          state.deliveryTimeSwatchData = await getSwatchData(stockConfig.customField);
        }
        state.deliveryTime = state.deliveryTimeSwatchData ? state.deliveryTimeSwatchData.find((s) => s.label === productAttributes.value[stockConfig.customField].value) || null : null;
      }
      error.value.attributeGroups = null;
    } catch (err) {
      error.value.attributeGroups = err;
    } finally {
      loading.value = false;
    }
    return state.attributeGroups;
  };
  const getSwatchData = async (attributeCode) => {
    var _a2;
    let result = null;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.customQuery({ query: getSwatchDataGql, queryVariables: { attributeCode } });
      result = ((_a2 = data == null ? void 0 : data.WmAttributeSwatchData) == null ? void 0 : _a2.items) || null;
      error.value.getSwatchData = null;
    } catch (err) {
      error.value.getSwatchData = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  function setAttributeGroups(attributeGroups) {
    state.attributeGroups = attributeGroups;
  }
  return {
    loading: readonly(loading),
    error: readonly(error),
    loadAttributeGroups,
    getSwatchData,
    customAttributeNames,
    specificationExcludeAtts,
    productIdentifiers,
    attributeGroups: computed(() => state.attributeGroups),
    deliveryTime: computed(() => state.deliveryTime),
    productAttributes,
    setAttributeGroups
  };
}
var useWmAttributes_default = useWmAttributes;
export {
  useWmAttributes_default as default,
  useWmAttributes
};
